module.exports = __webpack_public_path__ + "static/media/Portrait-10226.6402fbed.jpg";